module.exports = __webpack_public_path__ + "img/LogoZP.2ee1b7bf.png";